import {
  Form,
  FormRule,
  GetProp,
  InputNumber,
  InputNumberProps,
  Select,
  SelectProps,
} from 'antd';
import React, { FC, useMemo } from 'react';
import { NEGATIVE, POSITIVE } from './const';
import { FormItem } from './new';

interface Value {
  offset: number;
  direction: typeof POSITIVE | typeof NEGATIVE;
}

export const PositiveNegativeInputValidator = async (_: any, value: Value) => {
  if (value.direction === POSITIVE) {
    if (value.offset <= 0) return Promise.reject('偏移量必须为正数');
    return Promise.resolve('');
  }
  if (value.direction === NEGATIVE) {
    if (value.offset >= 0) return Promise.reject('偏移量必须为倒数');
    return Promise.resolve('');
  }
  return Promise.resolve('');
};

const PositiveNegativeInput: FC<{
  onChange?: (value: Partial<Value>) => void;
  value?: Value;
  inputNumberProps?: InputNumberProps;
  selectProps?: SelectProps;
}> = ({ onChange, value, inputNumberProps, selectProps }) => {
  const handleChange = (newValue: Partial<Value>) => {
    if (!newValue) return;

    onChange?.({
      ...value,
      ...newValue,
    });
  };

  // 都是正数
  const maxMin = useMemo(() => {
    // if (value?.direction === POSITIVE) {
    //   return { max: 99999, min: 0 };
    // }
    // return { max: -1, min: -99999 };
    return { max: 99999, min: 0 };
  }, [value?.direction]);

  return (
    <section className="flex gap-4 w-full">
      <div className="flex-1">
        <Select
          value={value?.direction}
          onChange={(direction) => {
            if (direction === POSITIVE) {
              handleChange({ direction, offset: 1 });
            } else {
              handleChange({ direction, offset: 1 });
            }
          }}
          options={[
            {
              label: '正数',
              value: POSITIVE,
            },
            {
              label: '倒数',
              value: NEGATIVE,
            },
          ]}
          {...selectProps}
        />
      </div>
      <div className="flex-2">
        <Form.Item noStyle shouldUpdate={() => true}>
          <InputNumber
            className="w-full"
            value={value?.offset}
            onChange={(offset) => {
              handleChange({
                offset: Number(offset) ?? 0,
              });
            }}
            {...maxMin}
            {...inputNumberProps}
          />
        </Form.Item>
      </div>
    </section>
  );
};

export default PositiveNegativeInput;
